/* eslint-disable */
import axios from 'axios';
import { jsonp } from '@ifeng-fe/ui_base';
let testVoteNumber = {
  baoxian:"6903989775858933760",
  jiazhuang:"6906470351132172288",
  xinnengyuan:"6903987828271616000",
  fangchanzhongjie:"6906475587288702976",
  xinnengyuanqiche:"6903987828271616000",
  qiche:"6903985149986217984",
  dichan:"6903980624554496000",
  chuxinglvyou:"6903978650400464896",
  dianqi:"6903976816235515904",
  yimei:"6903975708771491840",
  dianshang:"6903974237476757504",
  canyin:"6903971023314493440",
  quanshang:"6903966119824986112",
  yinhang:"6903962842257428480",
  shouye:"690647558728870297612",
}
let officeVoteNumber = {
  baoxian:"6903989775858933760",
  jiazhuang:"6906470351132172288",
  xinnengyuan:"6903987828271616000",
  fangchanzhongjie:"6906475587288702976",
  xinnengyuanqiche:"6903987828271616000",
  qiche:"6903985149986217984",
  dichan:"6903980624554496000",
  chuxinglvyou:"6903978650400464896",
  dianqi:"6903976816235515904",
  yimei:"6903975708771491840",
  dianshang:"6903974237476757504",
  canyin:"6903971023314493440",
  quanshang:"6903966119824986112",
  yinhang:"6903962842257428480",
  shouye:"690647558728870297612",
}
let commentData = {
  '6903962842257428480':'315财经投票_银行',
  '6903966119824986112':'315财经投票_券商',
  '6903971023314493440':'315财经投票_餐饮',
  '6903974237476757504':'315财经投票_电商',
  '6903975708771491840':'315财经投票_医美',
  "6903976816235515904":"315财经投票_电器",
  "6906470351132172288":'315财经投票_家装',
  '6903978650400464896':'315财经投票_出行旅游',
  '6903980624554496000':'315财经投票_地产',
  '6903985149986217984':'315财经投票_汽车',
  '6903987828271616000':'315财经投票_新能源',
  '6903989775858933760':'315财经投票_保险',
  '6906475587288702976':'315财经投票_房产中介',
  "690647558728870297612":'315财经投票_首页'
}
let voteNumber = NODE_ENV==='production' ?officeVoteNumber:testVoteNumber
let url =NODE_ENV==='production' ? 'https://external-gateway.ifengidc.com' :'https://external-gateway.ifengidc.com'
let commentUrl=NODE_ENV=== 'production' ? 'https://comment.ifeng.com' :"http://comment.ifeng.com"
function isMobile() {
  const flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
  );

  return flag;
}
export let whichEnv = () => {
  if (window.grounds) {
    return 'client';
  } else {
    // 手机端
    if (isMobile()) {
      return 'mobile';
    }
    // pc端
    else {
      return 'pc';
    }
  }
}
export let getToken = () =>{
  // 客户端

  if (whichEnv()==="client") {
    return window.grounds.getUserInfo().getToken()
  }
  if (isWechat()) {
    if (!window.localStorage.getItem('token')) {
      const callback = encodeURIComponent(
          `https://id.ifeng.com/sso/v1/?redirect=${encodeURIComponent(
             'https://news.ifeng.com/loc/315vote/index'
          )}`
      );

      const linkurl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9bd3b38f9c278ab4&redirect_uri=${callback}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;

      window.location.href = linkurl;
    }
    return window.localStorage.getItem('token')
    //return  '42771C27FD6E4C3285C62293FB01EC56'
  }
}
export const getAllData = async voteId => {

  try {
    const data = await axios(`${url}/vote/api/detail?voteId=${voteNumber[voteId]}`, {
      type: 'get',
      cache: false,
    });
    if (data.data.code === 200) {
      return data.data.data
    }
  } catch (e) {
    console.error(e);
  }
};
export const currentVoteStatus = async name => {
  let id = voteNumber[name]
  const { data } = await axios({
    method: 'get',
    url: `${url}/vote/api/currentVoteStatus?voteIds=${id}`,
    headers: {
      token: getToken()
      // TODO : 用于测试
      //token:'2687BFBFD337D0F27090FAFBF2171EF2'
    },
  });

  if (data?.code === 200) {
    return data.data;
  }
};
export const submitVote = async (data) => {
  const res = await axios({
    method: 'post',
    url: `${url}/vote/api/doVote`,
    headers: {
      'Content-Type': 'application/json',
      token : getToken(),
      //token:"2687BFBFD337D0F27090FAFBF2171EF2",
    },

    data,
  });
  return res
};
export const submitApi =async (content,name) => {
  console.log (commentData)
  let data = await jsonp (`${commentUrl}/post.php?docUrl=${voteNumber[name]}&docName=${encodeURIComponent(commentData[voteNumber[name]])}&skey=&format=js&content=${content}&permalink=http%3A%2F%2Ftest.news.ifeng.com%2Floc%2Fresult`, {
    jsonpCallback: 'postCmt',
    cache: false,
  });
  return data
}
export  const getTempCommentList = async (name) => {
  const data = await jsonp(`${commentUrl}/get/tempcomment`, {
    data: {
      doc_url:voteNumber[name],
      format: 'js',
    },
    jsonpCallback: 'getTempComments',
    cache: false,
  });

  // 格式化评论数据
  return data
};
//获取hot 标识的索引
export async function getHostIndex (){
  try {
    const data = await axios(`https://shankapi.ifeng.com/feedflow/get/struct/230201`, {
      type: 'get',
      cache: false,
    });

    return data.data.data

  } catch (e) {
    console.error(e);
  }
}
// 获取评论数据
export  const getHotList = async (name, page = 1) => {
  const data = await jsonp(`${commentUrl}/get.php`, {
    data: {
      orderby: 'uptimes',
      docUrl:voteNumber[name],
      format: 'js',
      job: 1,
      p: page,
      pageSize:100,
      skey: '',
    },
    jsonpCallback: 'newCommentListCallBack',
    cache: true,
  });

  // 格式化评论数据

  return data;
};
export const goNewPage =(url) => {
  if ( window.grounds) {
    window.grounds.dispatch('web', url);
  }
  else{
    window.location.href =url
  }
  if (window.location.href.indexOf('weixinEnv') > -1) {

  }
}
export let getHeaderHeight = () => {
  if (window.grounds) {
    //window.grounds.setMultiToolBarHidden(true);
  }else{
    return  0
  }
}
export function isWechat() {
  return /MicroMessenger/i.test(window.navigator.userAgent);
}

